import { isTextNode, isOneOfTags } from 'anodum';
import getAdvancedSelection from '../../text-formatting/accessors/get-advanced-selection';
import { LIST_ITEM, BLOCKQUOTE_ELEMENT } from '../constants/editable-elements';
import findRootEditableElement from './find-root-editable-element';
import wrapIntoElement from './wrap-into-element';
import getCollapsedNodeAndOffset from './get-collapsed-node-and-offset';
import findFirstTextNode from './find-first-text-node';
import insertBreakIntoEmptyEditableElement from './insert-break-into-empty-editable-element';
import matchListTagByString from './match-list-tag-by-string';
import operations from '../operations';
import setCaretAtTheBeginningOfNode from './set-caret-at-the-beginning-of-node';
import shouldUpdateNumberedList from './should-update-numbered-list';
import revertListListener from './revert-list-listener';
import StateMachine from './state-machine';
import isPreviousElementNumberedList from '../verifiers/is-previous-element-numbered-list';
import { DISABLE_CHECKPOINT } from '../constants/common';

const listInitState = new StateMachine({ isBlocked: false });

const handleListInitialization = (e) => {
  const selection = getAdvancedSelection();
  if (!selection.isCollapsed) return;

  if (listInitState.state.isBlocked) {
    listInitState.setState({ isBlocked: false });
    return;
  }

  const [node, offset] = getCollapsedNodeAndOffset();
  const editableElement = findRootEditableElement(node);

  /*
   TODO: Configure a restricted selectors for BLOCKQUOTE_ELEMENT
    when a configuration of text-formatting logic from the template will be ready
    https://github.com/yola/production/issues/8724
  */

  if (!editableElement || isOneOfTags(editableElement, [LIST_ITEM, BLOCKQUOTE_ELEMENT])) return;

  const firstTextNode = findFirstTextNode(editableElement, true);
  if (!firstTextNode || firstTextNode !== node || !isTextNode(node)) return;

  const leftText = firstTextNode.nodeValue.substring(0, offset);
  const listTag = matchListTagByString(leftText);

  let existedList = null;

  if (!listTag) {
    if (
      !isPreviousElementNumberedList(editableElement) ||
      !shouldUpdateNumberedList(leftText, editableElement.previousElementSibling)
    )
      return;

    existedList = editableElement.previousElementSibling;
  }
  operations.addCheckpoint();
  node.nodeValue = node.nodeValue.replace(leftText, '');

  if (!editableElement.innerText) {
    insertBreakIntoEmptyEditableElement(editableElement);
  }

  editableElement.style.removeProperty('text-align');

  const listItem = wrapIntoElement(editableElement, LIST_ITEM, true);

  if (existedList) {
    existedList.appendChild(listItem);
  } else {
    wrapIntoElement(listItem, listTag, true);
  }

  // Fix for the case when editable element has only spaces
  if (!editableElement.innerHTML.replace(/&nbsp;/g, '').trim()) {
    editableElement.innerHTML = '';
    editableElement.appendChild(document.createElement('br'));
  }

  setCaretAtTheBeginningOfNode(listItem);
  operations.addCheckpoint();
  e.preventDefault();
  e[DISABLE_CHECKPOINT] = true;

  const contentEditableElement = editableElement.closest('[contenteditable]');
  revertListListener(node.ownerDocument, contentEditableElement, listInitState);
};

export default handleListInitialization;
